import React, { useState, useEffect } from "react";
import Header from "../component/Home/Header";
import { calculateTestResult, mockQuestions as questions } from "../utils/mockQuestions";
import { Input } from "antd";
import Swal from "sweetalert2";
import MockTestResult from "../component/MockTest/MockTestResult";
import axios from "../axios";
import OTPInput from "react-otp-input";

export const MockTestInterface = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [flaggedQuestions, setFlaggedQuestions] = useState(new Set());
  const [timeRemaining, setTimeRemaining] = useState(5400); // 60 minutes in seconds
  const [testSubmitted, setTestSubmitted] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("")
  const [finalResult, setFinalResult] = useState(null);
  // Sample questions data

  // Timer effect
  useEffect(() => {
    if (!testSubmitted && timeRemaining > 0) {
      const timer = setTimeout(() => {
        setTimeRemaining(timeRemaining - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (timeRemaining === 0 && !testSubmitted) {
      handleSubmit();
    }
  }, [timeRemaining, testSubmitted]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  const handleAnswerSelect = (questionId, answerIndex) => {
    setSelectedAnswers({ ...selectedAnswers, [questionId]: answerIndex });
  };

  const handleFlagToggle = () => {
    const newFlagged = new Set(flaggedQuestions);
    if (newFlagged.has(questions[currentQuestion].id)) {
      newFlagged.delete(questions[currentQuestion].id);
    } else {
      newFlagged.add(questions[currentQuestion].id);
    }
    setFlaggedQuestions(newFlagged);
  };

  const handleSubmit = () => {
    setShowReviewModal(true);
  };

  const confirmSubmit = () => {
    // setTestSubmitted(true);
    setShowReviewModal(false);
    setShowEmailModal(true);
  };

  function evaluateAndGetResults() {
    const response = calculateTestResult(selectedAnswers, flaggedQuestions);
    setFinalResult(response);
  }

  async function submitMockTestEmail() {
    try {
      const url = "/dashboard-data/mckzp89d-vprsubm";
      const response = await axios.post(url, { email: email, finalResult, })
      if (response.status === 200) {
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  }

  function isStrictEmail(email) {
    console.log("Checking validness", email);
    if(!email) return false;
    const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}$/;
    console.log("validity result", re.test(email));
    return re.test(email);
  }

  const handleEmailSubmit = async () => {
    if (!isStrictEmail(email)) {
      Swal.fire({
        title: "Invalid Email",
        text: "Please enter a valid email address.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    setShowEmailModal(false);
    setTestSubmitted(true);
    evaluateAndGetResults();
    await submitMockTestEmail();
    Swal.fire({
      title: "Test Submitted Successfully!",
      text: "Your test has been submitted. Thank you for completing the test.",
      icon: "success",
      confirmButtonText: "OK",
    });
  };

  const getQuestionStatus = (questionId) => {
    if (selectedAnswers[questionId] !== undefined) return "answered";
    if (flaggedQuestions.has(questionId)) return "flagged";
    return "unanswered";
  };

  const getAnsweredCount = () => Object.keys(selectedAnswers).length;
  const getUnansweredCount = () => questions.length - getAnsweredCount();

  // Icons as SVG components
  const BookOpenIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
    </svg>
  );

  const TrophyIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
      <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
      <path d="M4 22h16"></path>
      <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
      <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
      <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
    </svg>
  );

  const TimerIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <line x1="10" x2="14" y1="2" y2="2"></line>
      <line x1="12" x2="15" y1="14" y2="11"></line>
      <circle cx="12" cy="14" r="8"></circle>
    </svg>
  );

  const FlagIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
      <line x1="4" x2="4" y1="22" y2="15"></line>
    </svg>
  );

  const ChevronLeftIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="m15 18-6-6 6-6"></path>
    </svg>
  );

  const ChevronRightIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="m9 18 6-6-6-6"></path>
    </svg>
  );

  const AlertCircleIcon = () => (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" x2="12" y1="8" y2="12"></line>
      <line x1="12" x2="12.01" y1="16" y2="16"></line>
    </svg>
  );

  return (
    <>
      {/* <Header /> */}
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%)",
          padding: "1rem",
        }}
      >
        {/* Header */}
        <div style={{ maxWidth: "1320px", margin: "0 auto 1.5rem" }}>
          <div
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              borderRadius: "1rem",
              boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
              padding: "1.5rem",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <div
                style={{ display: "flex", alignItems: "center", gap: "1rem" }}
              >
                <div
                  style={{
                    padding: "0.75rem",
                    background:
                      "linear-gradient(135deg, #007bff 0%, #6610f2 100%)",
                    borderRadius: "0.75rem",
                    color: "white",
                  }}
                >
                  <BookOpenIcon />
                </div>
                <div>
                  <h1
                    style={{
                      fontSize: "1.5rem",
                      fontWeight: "bold",
                      margin: 0,
                      color: "#212529",
                    }}
                  >
                    COMPTIA+ ADV Mock 1
                  </h1>
                  <p
                    style={{
                      fontSize: "0.875rem",
                      color: "#6c757d",
                      margin: 0,
                    }}
                  >
                    Core 1 - Section A
                  </p>
                </div>
              </div>

              <div
                style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    backgroundColor: "#fff3cd",
                    padding: "0.5rem 1rem",
                    borderRadius: "0.75rem",
                  }}
                >
                  <div style={{ color: "#ffc107" }}>
                    <TrophyIcon />
                  </div>
                  <span
                    style={{
                      fontSize: "0.875rem",
                      fontWeight: "600",
                      color: "#856404",
                    }}
                  >
                    500 Points
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    backgroundColor:
                      timeRemaining < 300 ? "#f8d7da" : "#d1e7dd",
                    padding: "0.5rem 1rem",
                    borderRadius: "0.75rem",
                  }}
                >
                  <div
                    style={{
                      color: timeRemaining < 300 ? "#dc3545" : "#198754",
                    }}
                  >
                    <TimerIcon />
                  </div>
                  <span
                    style={{
                      fontSize: "1.125rem",
                      fontWeight: "bold",
                      color: timeRemaining < 300 ? "#721c24" : "#155724",
                    }}
                  >
                    {formatTime(timeRemaining)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ maxWidth: "1320px", margin: "0 auto" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: "1.5rem",
            }}
          >
            <div style={{ display: "flex", flexWrap: "wrap", gap: "1.5rem" }}>
              {/* Main Content */}
              <div style={{ flex: "1 1 70%", minWidth: "300px" }}>
                <div
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    borderRadius: "1rem",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                    padding: "2rem",
                  }}
                >
                  {!testSubmitted ? (
                    <>
                      {/* Question Header */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "1.5rem",
                          paddingBottom: "1rem",
                          borderBottom: "1px solid #dee2e6",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.75rem",
                          }}
                        >
                          <span
                            style={{
                              padding: "0.5rem 0.75rem",
                              background:
                                "linear-gradient(135deg, #007bff 0%, #6610f2 100%)",
                              color: "white",
                              fontSize: "0.875rem",
                              fontWeight: "600",
                              borderRadius: "0.5rem",
                            }}
                          >
                            Question {currentQuestion + 1} of {questions.length}
                          </span>
                          <span
                            style={{
                              padding: "0.5rem 0.75rem",
                              backgroundColor: "#e2d5f1",
                              color: "#6f42c1",
                              fontSize: "0.875rem",
                              fontWeight: "500",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {questions[currentQuestion].subject}
                          </span>
                        </div>
                        <button
                          onClick={handleFlagToggle}
                          style={{
                            padding: "0.5rem",
                            borderRadius: "0.5rem",
                            border: "none",
                            backgroundColor: flaggedQuestions.has(
                              questions[currentQuestion].id
                            )
                              ? "#fed7aa"
                              : "#f1f3f5",
                            color: flaggedQuestions.has(
                              questions[currentQuestion].id
                            )
                              ? "#ea580c"
                              : "#9ca3af",
                            cursor: "pointer",
                            transition: "all 0.3s",
                          }}
                        >
                          <FlagIcon />
                        </button>
                      </div>

                      {/* Question */}
                      <div style={{ marginBottom: "2rem" }}>
                        <h2
                          style={{
                            fontSize: "1.25rem",
                            fontWeight: "600",
                            color: "#212529",
                            marginBottom: "1.5rem",
                          }}
                        >
                          {questions[currentQuestion].question}
                        </h2>

                        {/* Options */}
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.75rem",
                          }}
                        >
                          {questions[currentQuestion].options.map(
                            (option, index) => (
                              <button
                                key={index}
                                onClick={() =>
                                  handleAnswerSelect(
                                    questions[currentQuestion].id,
                                    index
                                  )
                                }
                                style={{
                                  width: "100%",
                                  padding: "1rem",
                                  textAlign: "left",
                                  borderRadius: "0.75rem",
                                  border:
                                    selectedAnswers[
                                      questions[currentQuestion].id
                                    ] === index
                                      ? "2px solid #007bff"
                                      : "2px solid #dee2e6",
                                  backgroundColor:
                                    selectedAnswers[
                                      questions[currentQuestion].id
                                    ] === index
                                      ? "#e7f1ff"
                                      : "white",
                                  cursor: "pointer",
                                  transition: "all 0.3s",
                                  transform: "scale(1)",
                                }}
                                onMouseEnter={(e) =>
                                (e.currentTarget.style.transform =
                                  "scale(1.02)")
                                }
                                onMouseLeave={(e) =>
                                  (e.currentTarget.style.transform = "scale(1)")
                                }
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.75rem",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      borderRadius: "50%",
                                      border:
                                        selectedAnswers[
                                          questions[currentQuestion].id
                                        ] === index
                                          ? "2px solid #007bff"
                                          : "2px solid #dee2e6",
                                      backgroundColor:
                                        selectedAnswers[
                                          questions[currentQuestion].id
                                        ] === index
                                          ? "#007bff"
                                          : "transparent",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {selectedAnswers[
                                      questions[currentQuestion].id
                                    ] === index && (
                                        <div
                                          style={{
                                            width: "12px",
                                            height: "12px",
                                            backgroundColor: "white",
                                            borderRadius: "50%",
                                          }}
                                        ></div>
                                      )}
                                  </div>
                                  <span
                                    style={{
                                      fontSize: "1.125rem",
                                      color:
                                        selectedAnswers[
                                          questions[currentQuestion].id
                                        ] === index
                                          ? "#0056b3"
                                          : "#212529",
                                      fontWeight:
                                        selectedAnswers[
                                          questions[currentQuestion].id
                                        ] === index
                                          ? "500"
                                          : "normal",
                                    }}
                                  >
                                    {String.fromCharCode(65 + index)}. {option}
                                  </span>
                                </div>
                              </button>
                            )
                          )}
                        </div>
                      </div>

                      {/* Navigation */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingTop: "1.5rem",
                          borderTop: "1px solid #dee2e6",
                        }}
                      >
                        <button
                          onClick={() =>
                            setCurrentQuestion(Math.max(0, currentQuestion - 1))
                          }
                          disabled={currentQuestion === 0}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            padding: "0.75rem 1.5rem",
                            borderRadius: "0.75rem",
                            border: "none",
                            backgroundColor:
                              currentQuestion === 0 ? "#e9ecef" : "#6c757d",
                            color: currentQuestion === 0 ? "#adb5bd" : "white",
                            fontWeight: "500",
                            cursor:
                              currentQuestion === 0 ? "not-allowed" : "pointer",
                            transition: "all 0.3s",
                          }}
                        >
                          <ChevronLeftIcon />
                          Previous
                        </button>

                        {currentQuestion === questions.length - 1 ? (
                          <button
                            onClick={handleSubmit}
                            style={{
                              padding: "0.75rem 2rem",
                              background:
                                "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                              color: "white",
                              fontWeight: "600",
                              borderRadius: "0.75rem",
                              border: "none",
                              cursor: "pointer",
                              transition: "all 0.3s",
                              transform: "scale(1)",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "scale(1.05)";
                              e.currentTarget.style.boxShadow =
                                "0 5px 15px rgba(0,0,0,0.2)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "scale(1)";
                              e.currentTarget.style.boxShadow = "none";
                            }}
                          >
                            Submit Test
                          </button>
                        ) : (
                          <button
                            onClick={() =>
                              setCurrentQuestion(
                                Math.min(
                                  questions.length - 1,
                                  currentQuestion + 1
                                )
                              )
                            }
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "0.5rem",
                              padding: "0.75rem 1.5rem",
                              background:
                                "linear-gradient(135deg, #007bff 0%, #6610f2 100%)",
                              color: "white",
                              fontWeight: "500",
                              borderRadius: "0.75rem",
                              border: "none",
                              cursor: "pointer",
                              transition: "all 0.3s",
                            }}
                            onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                              "0 5px 15px rgba(0,0,0,0.2)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.boxShadow = "none")
                            }
                          >
                            Next
                            <ChevronRightIcon />
                          </button>
                        )}
                      </div>
                    </>
                  ) : finalResult && (
                    <MockTestResult finalResult={finalResult} />
                  )}
                </div>
              </div>

              {/* Sidebar */}
              <div style={{ flex: "0 0 280px", minWidth: "280px" }}>
                <div
                  style={{
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    borderRadius: "1rem",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                    padding: "1.5rem",
                    position: "sticky",
                    top: "1rem",
                  }}
                >
                  <h3
                    style={{
                      fontSize: "1.125rem",
                      fontWeight: "600",
                      color: "#212529",
                      marginBottom: "1rem",
                    }}
                  >
                    Question Navigator
                  </h3>

                  {/* Stats */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "0.75rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#d1e7dd",
                        padding: "0.75rem",
                        borderRadius: "0.75rem",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "0.75rem",
                          color: "#6c757d",
                          margin: 0,
                        }}
                      >
                        Answered
                      </p>
                      <p
                        style={{
                          fontSize: "1.25rem",
                          fontWeight: "bold",
                          color: "#155724",
                          margin: 0,
                        }}
                      >
                        {getAnsweredCount()}
                      </p>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#f8f9fa",
                        padding: "0.75rem",
                        borderRadius: "0.75rem",
                      }}
                    >
                      <p
                        style={{
                          fontSize: "0.75rem",
                          color: "#6c757d",
                          margin: 0,
                        }}
                      >
                        Unanswered
                      </p>
                      <p
                        style={{
                          fontSize: "1.25rem",
                          fontWeight: "bold",
                          color: "#495057",
                          margin: 0,
                        }}
                      >
                        {getUnansweredCount()}
                      </p>
                    </div>
                  </div>

                  {/* Question Grid */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(5, 1fr)",
                      gap: "0.5rem",
                      marginBottom: "1.5rem",
                    }}
                  >
                    {questions.map((q, index) => (
                      <button
                        key={q.id}
                        onClick={() => setCurrentQuestion(index)}
                        style={{
                          padding: "0.5rem",
                          borderRadius: "0.5rem",
                          border: "none",
                          fontSize: "0.875rem",
                          fontWeight: "500",
                          cursor: "pointer",
                          transition: "all 0.3s",
                          background:
                            currentQuestion === index
                              ? "linear-gradient(135deg, #007bff 0%, #6610f2 100%)"
                              : getQuestionStatus(q.id) === "answered"
                                ? "#d4edda"
                                : flaggedQuestions.has(q.id)
                                  ? "#f7f7f7"
                                  : "#f7f7f7",
                          color:
                            currentQuestion === index
                              ? "white"
                              : getQuestionStatus(q.id) === "answered"
                                ? "#155724"
                                : flaggedQuestions.has(q.id)
                                  ? "#856404"
                                  : "#6c757d",
                          boxShadow:
                            currentQuestion === index
                              ? "0 4px 6px rgba(0,0,0,0.1)"
                              : "none",
                          border: "1px solid #eee",
                        }}
                      >
                        {index + 1}
                      </button>
                    ))}
                  </div>

                  {/* Legend */}
                  <div
                    style={{
                      paddingTop: "1rem",
                      borderTop: "1px solid #dee2e6",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#d4edda",
                          borderRadius: "0.25rem",
                        }}
                      ></div>
                      <span style={{ fontSize: "0.875rem", color: "#6c757d" }}>
                        Answered
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                        marginBottom: "0.5rem",
                      }}
                    >
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#fff3cd",
                          borderRadius: "0.25rem",
                        }}
                      ></div>
                      <span style={{ fontSize: "0.875rem", color: "#6c757d" }}>
                        Flagged
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <div
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#f8f9fa",
                          borderRadius: "0.25rem",
                        }}
                      ></div>
                      <span style={{ fontSize: "0.875rem", color: "#6c757d" }}>
                        Not Visited
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showEmailModal && (
          <div
            style={{
              position: "fixed",
              backdropFilter: "blur(10px)",
              inset: "0",
              zIndex: "1000",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
              background: "rgba(153, 149, 218, 0.44)",
            }}
          >
            <div
              style={{
                color: "black",
                background: "#fff",
                padding: "32px 24px",
                borderRadius: "12px",
                maxWidth: "450px",
                width: "100%",
                boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "20px",
                  marginBottom: "20px",
                }}
              >
                <div
                  style={{
                    padding: "0.75rem",
                    background:
                      "linear-gradient(135deg, #007bff 0%, #6610f2 100%)",
                    borderRadius: "0.75rem",
                    color: "white",
                  }}
                >
                  <BookOpenIcon />
                </div>
                <h5 style={{ fontSize: "24px", fontWeight: "600", margin: 0 }}>
                  Test Completed
                </h5>
              </div>
              <h4
                style={{
                  marginTop: "10px",
                  fontSize: "18px",
                  fontWeight: "500",
                }}
              >
                Please enter your email
              </h4>
              <p style={{ color: "#6c757d", marginBottom: "20px" }}>
                Please enter a valid email.
              </p>
              <div style={{ marginBottom: "20px" }}>
                <label
                  style={{
                    display: "flex",
                    alignItems:"center",
                    justifyContent:'space-between',
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  Email
                  {/* <button style={{background:"none", border:"none", outline:"none", fontWeight:"600", color:"blue"}}>Send</button> */}
                </label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    border: "1px solid #ced4da",
                  }}
                  placeholder="Enter your email address"
                />
                
              </div>
             
              <div style={{ display: "flex", gap: "10px" }}>
                <button
                  onClick={handleEmailSubmit}
                  style={{
                    padding: "10px 20px",
                    background:
                      "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    flex: "1",
                  }}
                >
                  Submit
                </button>
                <button
                  onClick={() => setShowEmailModal(false)}
                  style={{
                    padding: "10px 20px",
                    background: "#f8f9fa",
                    color: "#6c757d",
                    fontWeight: "600",
                    borderRadius: "8px",
                    border: "1px solid #ced4da",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Review Modal */}
        {showReviewModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "1rem",
              zIndex: 1050,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "1rem",
                padding: "2rem",
                maxWidth: "400px",
                width: "100%",
                boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "1rem",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#fff3cd",
                    borderRadius: "50%",
                    padding: "1rem",
                  }}
                >
                  <div style={{ color: "#ffc107" }}>
                    <AlertCircleIcon />
                  </div>
                </div>
              </div>
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  textAlign: "center",
                  marginBottom: "1rem",
                }}
              >
                Submit Test?
              </h3>
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  borderRadius: "0.75rem",
                  padding: "1rem",
                  marginBottom: "1.5rem",
                }}
              >
                <p
                  style={{
                    fontSize: "0.875rem",
                    color: "#6c757d",
                    marginBottom: "0.75rem",
                  }}
                >
                  Test Summary:
                </p>
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <span style={{ fontSize: "0.875rem", color: "#6c757d" }}>
                      Questions Attempted:
                    </span>
                    <span style={{ fontSize: "0.875rem", fontWeight: "600" }}>
                      {getAnsweredCount()}/{questions.length}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <span style={{ fontSize: "0.875rem", color: "#6c757d" }}>
                      Unanswered:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "600",
                        color: "#ea580c",
                      }}
                    >
                      {getUnansweredCount()}
                    </span>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span style={{ fontSize: "0.875rem", color: "#6c757d" }}>
                      Flagged:
                    </span>
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: "600",
                        color: "#d97706",
                      }}
                    >
                      {flaggedQuestions.size}
                    </span>
                  </div>
                </div>
              </div>
              <p
                style={{
                  textAlign: "center",
                  color: "#6c757d",
                  marginBottom: "1.5rem",
                }}
              >
                Are you sure you want to submit? You won't be able to change
                your answers.
              </p>
              <div style={{ display: "flex", gap: "0.75rem" }}>
                <button
                  onClick={() => setShowReviewModal(false)}
                  style={{
                    flex: 1,
                    padding: "0.75rem",
                    backgroundColor: "#6c757d",
                    color: "white",
                    fontWeight: "500",
                    borderRadius: "0.75rem",
                    border: "none",
                    cursor: "pointer",
                    transition: "all 0.3s",
                  }}
                >
                  Review Answers
                </button>
                <button
                  onClick={confirmSubmit}
                  style={{
                    flex: 1,
                    padding: "0.75rem",
                    background:
                      "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                    color: "white",
                    fontWeight: "500",
                    borderRadius: "0.75rem",
                    border: "none",
                    cursor: "pointer",
                    transition: "all 0.3s",
                  }}
                >
                  Confirm Submit
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
